<template>
<ButtonPrimaryDark v-on="$listeners" class="v-btn--distribute-lead">
  <template v-slot:icon>
    <DistributeLeadIcon/>
  </template>
  <template v-slot:text>
    {{$t('buttons.distributeLead')}}
  </template>
</ButtonPrimaryDark>
</template>

<script>
import ButtonPrimaryDark from "./templates/ButtonPrimary";
import DistributeLeadIcon from "../icons/DistributeLeadIcon";
export default {
  name: "ButtonPrimaryAction",
  components: {DistributeLeadIcon, ButtonPrimaryDark}
}
</script>

<style scoped lang="scss">
</style>

<!-- The following style have to be declared as global styles, otherwise they have no effect. -->
<style lang="scss">
.v-btn--distribute-lead {
  svg {
    .a {
      stroke: $white;
    }
  }

  &:hover {
    svg {
      .a {
        stroke: map-get($green, 'base');
      }
    }
  }
}
</style>
